module.exports = __webpack_public_path__ + "img/news_03.befcb9e2.jpg";